export const downloadURL = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.rel = 'noopener'; // tabnabbing
  link.href = url;
  link.click();
};
